import { Cart } from '@/types/generated/graphql'
import cartQuery from '@/graphql/order/cart.gql'

export class LoadResult {
  readonly isLoaded: boolean
  readonly result: Cart | null

  constructor(isLoaded: boolean, result: Cart | null = null) {
    this.isLoaded = isLoaded
    this.result = result
  }
}

export default class GoodsPriceLoader {
  private readonly vm: Vue
  private readonly delay: number
  private timeout: NodeJS.Timeout | null = null

  constructor(vm: Vue, delay = 500) {
    this.vm = vm
    this.delay = delay
  }

  public async loadPrice(
    productId: string,
    quantity: number
  ): Promise<LoadResult> {
    if (this.timeout !== null) {
      clearTimeout(this.timeout)
    }

    return new Promise((resolve) => {
      this.timeout = setTimeout(async () => {
        this.timeout = null
        const cart = await this.getCart(productId, quantity)
        if (this.timeout === null) {
          resolve(new LoadResult(true, cart))
        } else {
          resolve(new LoadResult(false, null))
        }
      }, this.delay)
    })
  }

  private async getCart(productId: string, quantity: number): Promise<Cart> {
    const { data } = await this.vm.$apollo.query({
      query: cartQuery,
      variables: {
        input: {
          items: [{ productId, quantity }],
        },
      },
    })

    return data.cart
  }
}
